
const state = {
  lowsourceInfo: []
}

const actions = {
  updateData (ctx, item) {
    ctx.commit('updateData', item)
  }
}

const mutations = {
  updateData (state, item) {
    state.lowsourceInfo = item
  }
}

export default{
  namespaced: true,
  state,
  actions,
  mutations
}
